export const InputFields = [
  {
    collum: 12,
    key: 'username',
    type: 'text',
    name: 'Tên tài khoản',
    icon: 'fa-solid fa-user-tie',
    required: true,
    errorKey: 'username',
  },
  {
    collum: 6,
    key: 'password',
    type: 'password',
    name: 'Mật khẩu',
    icon: 'fas fa-lock',
    required: true,
    errorKey: 'password',
  },
  {
    collum: 6,
    key: 'rePassword',
    type: 'password',
    name: 'Nhập lại mật khẩu',
    icon: 'fas fa-lock',
    required: true,
    errorKey: 'rePassword',
  },
  {
    collum: 6,
    key: 'code',
    type: 'text',
    name: 'MSSV của bạn',
    icon: 'fa-solid fa-address-card',
    required: true,
    errorKey: 'code',
  },
  {
    collum: 6,
    key: 'full_name',
    type: 'text',
    name: 'Họ và tên của bạn',
    icon: 'fa-regular fa-calendar-days',
    required: true,
    errorKey: 'full_name',
  },
  {
    collum: 6,
    key: 'date_of_birth',
    type: 'date',
    name: 'Ngày sinh',
    icon: 'far fa-calendar-alt',
    required: true,
    errorKey: 'date_of_birth',
  },
  {
    collum: 6,
    key: 'gender',
    type: 'radio',
    listRadio: [
      {
        label: 'Nam',
        value: 'male',
      },
      {
        label: 'Nữ',
        value: 'female',
      },
      {
        label: 'Khác',
        value: 'other',
      },
    ],
    name: 'Giới tính',
    icon: 'fas fa-venus-mars',
    required: true,
    errorKey: 'gender',
  },
  {
    collum: 6,
    key: 'email',
    type: 'email',
    name: 'Email',
    icon: 'fa-solid fa-envelope-open-text',
    required: true,
    errorKey: 'email',
  },
  {
    collum: 6,
    key: 'phone_number',
    type: 'text',
    name: 'Số điện thoại',
    icon: 'fa-solid fa-phone-volume',
    required: true,
    errorKey: 'phone_number',
  },

  {
    collum: 12,
    key: 'address',
    type: 'text',
    name: 'Địa chỉ',
    icon: 'fa-solid fa-map-location-dot',
    required: true,
    errorKey: 'address',
  },
  {
    collum: 12,
    key: 'avatar_url',
    type: 'text',
    name: 'Ảnh đại diện ',
    icon: 'fa-regular fa-image',
    required: false,
    errorKey: 'avatar_url',
  },
];
